/* eslint-disable max-len */
import React from 'react';
import { withUserConfigGuard } from '../hoc/userConfigGuard';
import { withTabs } from '../hoc/tabs';
import { FileExplorer } from '../components/fileExplorer/fileExplorer';
import { CurrentFolderUploadMenu } from '../components/fileExplorer/components/uploadMenu';
import { withLicenseLevelGuard } from '../hoc/licenseLevelGuard';
import { LicenseLevel } from '@sendent/nextcloud-api';
import { FileModal } from '../components/fileExplorer/components/FileModal';
import './nextcloudExplorer.css';
import { withTeamContextGuard } from '../hoc/teamContextGuard';
import withDefaultFolderData from '../components/fileExplorer/withDefaultFolderData';
import { DefaultFolderModal } from '../components/fileExplorer/components/fileDropdownButton';

const NextcloudExplorerPage = () => {
    return (
        <div className="nextcloud-explorer-page">
            <CurrentFolderUploadMenu />
            <FileExplorer />
            <FileModal />
            <DefaultFolderModal />
        </div>
    );
};

export default withTabs(
    withUserConfigGuard(
        withTeamContextGuard(
            withDefaultFolderData(
                withLicenseLevelGuard(
                    NextcloudExplorerPage,
                    LicenseLevel.Standard,
                ),
            ),
        ),
    ),
);
